"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEarliestUpdateNotBefore = getEarliestUpdateNotBefore;
exports.default = void 0;

var _react = require("react");

var _simpleUpdateIn = _interopRequireDefault(require("simple-update-in"));

var _findMin = _interopRequireDefault(require("../Utils/findMin"));

var _useForceRender = _interopRequireDefault(require("./internal/useForceRender"));

var _useNotifications3 = _interopRequireDefault(require("./useNotifications"));

var _useStyleOptions3 = _interopRequireDefault(require("./useStyleOptions"));

var _useTimer = _interopRequireDefault(require("./internal/useTimer"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function getEarliestUpdateNotBefore(notificationMap) {
  return (0, _findMin.default)(Object.values(notificationMap).filter(function (_ref) {
    var outOfDate = _ref.outOfDate;
    return outOfDate;
  }).map(function (_ref2) {
    var updateNotBefore = _ref2.updateNotBefore;
    return updateNotBefore;
  }));
}

function useDebouncedNotifications() {
  var now = Date.now();

  var _useStyleOptions = (0, _useStyleOptions3.default)(),
      _useStyleOptions2 = _slicedToArray(_useStyleOptions, 1),
      notificationDebounceTimeout = _useStyleOptions2[0].notificationDebounceTimeout;

  var _useNotifications = (0, _useNotifications3.default)(),
      _useNotifications2 = _slicedToArray(_useNotifications, 1),
      notifications = _useNotifications2[0];

  var debouncedNotificationsRef = (0, _react.useRef)({});
  var forceRender = (0, _useForceRender.default)(); // Delete notifications or mark them to be deleted if debouncing.

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = Object.keys(debouncedNotificationsRef.current).filter(function (id) {
      return !(id in notifications);
    })[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var id = _step.value;
      debouncedNotificationsRef.current = (0, _simpleUpdateIn.default)(debouncedNotificationsRef.current, [id], function (debouncedNotification) {
        if (now < debouncedNotification.updateNotBefore) {
          // The update need to be postponed.
          return _objectSpread({}, debouncedNotification, {
            outOfDate: true
          });
        } // Otherwise, return undefined will remove it.

      });
    } // For any changes, update notifications or mark them to be updated if debouncing.

  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  var _loop = function _loop() {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i2], 2),
        _Object$entries$_i$ = _Object$entries$_i[1],
        alt = _Object$entries$_i$.alt,
        data = _Object$entries$_i$.data,
        id = _Object$entries$_i$.id,
        level = _Object$entries$_i$.level,
        message = _Object$entries$_i$.message,
        timestamp = _Object$entries$_i$.timestamp;

    debouncedNotificationsRef.current = (0, _simpleUpdateIn.default)(debouncedNotificationsRef.current, [id], function (debouncedNotification) {
      if (debouncedNotification && alt === debouncedNotification.alt && Object.is(data, debouncedNotification.data) && level === debouncedNotification.level && message === debouncedNotification.message && timestamp === debouncedNotification.timestamp) {
        // If nothing changed, return as-is.
        return debouncedNotification;
      }

      if (debouncedNotification && now < debouncedNotification.updateNotBefore) {
        // The update need to be postponed.
        return _objectSpread({}, debouncedNotification, {
          outOfDate: true
        });
      } // Update the notification.


      return _objectSpread({}, debouncedNotification, {
        alt: alt,
        data: data,
        id: id,
        level: level,
        message: message,
        outOfDate: false,
        timestamp: timestamp,
        updateNotBefore: now + notificationDebounceTimeout
      });
    });
  };

  for (var _i2 = 0, _Object$entries = Object.entries(notifications); _i2 < _Object$entries.length; _i2++) {
    _loop();
  }

  (0, _useTimer.default)(getEarliestUpdateNotBefore(debouncedNotificationsRef.current), forceRender);
  return [debouncedNotificationsRef.current];
}

var _default = useDebouncedNotifications;
exports.default = _default;